import { Box, Divider, Tooltip, Typography } from "@mui/material";
import { senecColors } from "src/styles/senecBaseThemePalette";
import { Bar, StackedBarData } from "src/components/monitoring/senec-stacked-bar-chart/SenecStackedBarChart";
import { Chip } from "@nivo/tooltip";
import TableRow from "@mui/material/TableRow";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";

export const HoverItem = ({
    index,
    stackedBarGroupWidth,
    stackedBarTotalWidth,
    stackedBarData,
    setIndex,
    showTooltip,
}: {
    index: number | null;
    stackedBarGroupWidth: number;
    stackedBarTotalWidth: number;
    stackedBarData: StackedBarData[];
    setIndex(index: number | null): void;
    showTooltip: boolean;
}) => {
    const BarChartTooltip = ({ data }: { data: StackedBarData }) => {
        if (isDataExist(data) && showTooltip) {
            const barItems: Bar[] | undefined = [];
            data.stackedBarItems?.map((item) => {
                if (item.lower) {
                    barItems.push(...[item.lower]);
                }
                if (item.middle) {
                    barItems.push(...[item.middle]);
                }
                if (item.upper) {
                    barItems.push(...[item.upper]);
                }
            });
            return (
                <Tooltip
                    sx={{
                        background: senecColors.white,
                        borderRadius5: "10px",
                        borderColor: senecColors.neutralGray00,
                    }}
                    title={
                        <>
                            <Typography fontWeight="bold" p="0.5rem 0.25rem">
                                {data.label}
                            </Typography>
                            <Divider sx={{ mb: "0.5rem" }} />
                        </>
                    }
                >
                    <TableContainer component={Paper}>
                        <Table size="small">
                            <TableBody>
                                <TableRow>
                                    <TableCell align="left" colSpan={3} sx={{ padding: "6px 6px", border: "none" }}>
                                        <Typography fontWeight="bold" p="0.5rem 0.25rem">
                                            {data.label}
                                        </Typography>
                                        <Divider sx={{ mb: "0.5rem" }} />
                                    </TableCell>
                                </TableRow>
                                {barItems.map((item) => (
                                    <>
                                        <TableRow>
                                            <TableCell align="left" sx={{ padding: "6px 6px", border: "none" }}>
                                                <Chip
                                                    key={`${item}_chip`}
                                                    color={item.color || senecColors.white}
                                                    style={{ marginBottom: "3px" }}
                                                />
                                            </TableCell>
                                            <TableCell
                                                align="left"
                                                sx={{ padding: "6px 6px", border: "none", whiteSpace: "nowrap" }}
                                            >
                                                <Typography key={`${item}_label`}>{item.label}</Typography>
                                            </TableCell>
                                            <TableCell align="right" sx={{ padding: "6px 6px", border: "none" }}>
                                                <Typography key={`${item}_value`} fontWeight="bold" align="right">
                                                    {Math.round(item.value * 10) / 10}
                                                </Typography>
                                            </TableCell>
                                        </TableRow>
                                    </>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </Tooltip>
            );
        } else {
            return <></>;
        }
    };
    return (
        <>
            {index != undefined && (
                <>
                    <Box
                        sx={{
                            background: senecColors.neutralGray00,
                            position: "absolute",
                            left: calculatePositionForHoverItem(
                                index,
                                stackedBarData.length,
                                stackedBarTotalWidth,
                                stackedBarGroupWidth,
                            ),
                            top: "-16px",
                            height: "362px",
                            width: stackedBarGroupWidth,
                        }}
                    >
                        <div style={{ position: "absolute", right: "120%", zIndex: 20, padding: "1px" }}>
                            <BarChartTooltip data={stackedBarData[index]} />
                        </div>
                    </Box>
                </>
            )}
            {stackedBarData.map((_, i) => (
                <Box
                    key={i}
                    sx={{
                        position: "absolute",
                        left: (i * stackedBarTotalWidth) / stackedBarData.length,
                        height: "346px",
                        width: stackedBarTotalWidth / stackedBarData.length,
                        zIndex: 20,
                    }}
                    onMouseEnter={() => setIndex(i)}
                    onMouseLeave={() => setIndex(null)}
                ></Box>
            ))}
        </>
    );
};

function calculatePositionForHoverItem(index: number, size: number, totalWidth: number, groupWidth: number): number {
    if (totalWidth === 0 || groupWidth === 0 || size === 0) return 0;

    const areaWidth = totalWidth / size;
    const center = (areaWidth - groupWidth) / 2;
    return center + index * areaWidth + 32;
}
function isDataExist(data: StackedBarData): boolean {
    return (
        data.stackedBarItems?.find((item) => {
            return !!(item.lower || item.middle || item.upper);
        }) !== undefined
    );
}
